export default __webpack_public_path__ + "static/media/Northernlights.faf3398d.png";